import React from 'react';
import Publication from "../../components/publication";
class PERSUASIVE2025 extends Publication{
    get_abstract(){
        return(
            <div className="border border-3 p-3 rounded-2">
                <h2>Abstract:</h2>
                <p>
                Deceptive Design, also known as "Dark Patterns", manipulates users through
                interface design that exploits cognitive biases, psychology, and design
                standards to extract money, data, or attention. As governments act against such
                practices, it is crucial to distinguish them from benevolent design approaches
                like Persuasive Technology, which aims to influence user behavior positively.
                By condensing the past decade of Dark Pattern taxonomies with Straussian
                Grounded Theory (SGT), we have created a set of five heuristics diagnostic of
                manipulative design. We present the results of a small study using these
                heuristics and propose that our heuristic evaluation (HE) process can enhance
                the assessment of Persuasive Technology.
                </p>
            </div>
        )
    }
}

export default PERSUASIVE2025;